import {
    apiRequest,
    diklatTrainingList,
    diklatUpdate,
    diklatDetail
} from "../../../../../services/adapters/kepegawaian/diklatService"

class UpdateRepository {

    fetchTrainingList = async (query, cancelToken) => {
        return await apiRequest("get", diklatTrainingList, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", diklatUpdate, {
            body: query
        }, true)
    }
    
    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", diklatDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

}

export default UpdateRepository